export default __webpack_public_path__ + "c6d1277661fdef4041430ec234f7a99e.png";